// Static rep list for the Rep filter chip.
// Sourced from the Claude Design "AdventureWorks Executive Dashboard" mock.
// Replace with a real list once the rep dimension is wired.

export const SALESPEOPLE = [
  { name: 'Jillian Carson',      territory: 'Northwest' },
  { name: 'Linda Mitchell',      territory: 'Southwest' },
  { name: 'Michael Blythe',      territory: 'Northeast' },
  { name: 'Tsvi Reiter',         territory: 'Southeast' },
  { name: 'Jae Pak',             territory: 'Canada'    },
  { name: 'Shu Ito',             territory: 'Pacific'   },
  { name: 'Rachel Valdez',       territory: 'Europe'    },
  { name: 'José Saraiva',        territory: 'Europe'    },
  { name: 'Pamela Ansman-Wolfe', territory: 'Central'   },
  { name: 'Garrett Vargas',      territory: 'Canada'    },
];
